module.exports = __webpack_public_path__ + "static/assets/lia-stone-profile.8cbc4b4.png";